export default __webpack_public_path__ + "static/anna_lego-81964e1da9b4f97f693f74cc2c7abcb3.png";